<template>
  <!-- Language fallback disabled as lang switching is not currently being implemented -->
  <!-- <MBZLanguageFallbackBanner v-if="isLanguageFallback" /> -->
  <component :is="renderCustomElements(page?.content)" v-if="page?.content" />
</template>

<script lang="ts" setup>
const { fetchPage, usePageHead, renderCustomElements } = useDrupalCe();
const { setUser } = useCurrentUser();
const route = useRoute();

// nuxt.config > `customErrorPages: true`
// means fetchPage will show the correct response
// (404/403/500/backend-down) and redirects us to error.vue
const page = await fetchPage(route.path, { query: route.query });

// Update current user state from Drupal response.
if (page.value?.current_user) {
  setUser(page.value.current_user);
}

// Redirect authenticated users away from login page and user profile pages.
if (
  page.value?.current_user?.id > 0 &&
  (route.path === '/user/login' || /^\/user\/\d+/.test(route.path))
) {
  await navigateTo('/', { replace: true });
} else {
  // Fallback for when "Page not found" or "Access denied" page returned with a 200 body.
  if (
    page.value?.title === 'Page not found' ||
    page.value?.title === 'Access denied'
  ) {
    throw createError({
      statusCode: 404,
      statusMessage: 'Page Not Found',
      fatal: true,
    });
  }

  usePageHead(page);
}

definePageMeta({
  key: (route) => route.fullPath.split('#')[0] || '',
});
</script>
